import { Targets } from '@atlassiansox/cross-flow-base-types';
import {
	SERVICE_DESK_PROJECT,
	PRODUCT_DISCOVERY_PROJECT,
	CUSTOMER_SERVICE_PROJECT,
	SOFTWARE_PROJECT,
	CORE_PROJECT,
} from '@atlassian/jira-common-constants/src/project-types.tsx';

export const getProductTypeKeyFromTargetProduct = (targetProduct: string): string | undefined => {
	if (targetProduct === Targets.JIRA_PRODUCT_DISCOVERY) {
		return PRODUCT_DISCOVERY_PROJECT;
	}
	if (targetProduct === Targets.JIRA_SERVICE_DESK) {
		return SERVICE_DESK_PROJECT;
	}
	if (targetProduct === Targets.JIRA_SOFTWARE) {
		return SOFTWARE_PROJECT;
	}
	if (targetProduct === Targets.JIRA_CUSTOMER_SERVICE) {
		return CUSTOMER_SERVICE_PROJECT;
	}
	if (targetProduct === Targets.JIRA_CORE) {
		return CORE_PROJECT;
	}

	return undefined;
};
